<template>
  <div>
    <div class="section" style="min-width: 1200px;">
      <span class="title">
        {{ $t('SeaExport.DoorToDoorLoading') }}
        <span
          style="color: red; font-weight:lighter;margin:30px;"
        >注：1、{{ $t('SeaExport.SaveBusinessBeforeEnterMultiGate') }}；2、<span v-if="job.dischargingPortDoor">若需指定目的港运输公司，请维护运输公司字段，未维护时尾程商务会进行分配</span></span>
        <el-button v-if="(job.lob === 'SE' || job.lob === 'AE') && readonly && showSync" type="primary" @click="exportSyncImport">{{ $t('SeaExport.Synchronization') }}</el-button>
      </span>
      <div style="display:flex;flex-direction:column">
        <div v-show="job.multipleDischargingPickups">
          <cargo-ag-grid
            v-if="top.visible"
            no="1"
            :config-module="topConfigModuel"
            :grid-options="top.gridOptions"
            :column-defs="topColumnDefs"
            :row-data="trucking"
            style="width:100%;"
            @gridReady="params=>{topGridApi=params.api}"
          />
        </div>
        <div v-if="!isMaster && job.multipleDischargingPickups" class="app-main-inner-row operations" style="padding:5px 0">
          <div v-show="cooperateEdit" class="triggers">
            <div>
              <el-button
                no="2"
                type="primary"
                :disabled="readonly||!addEnable"
                @click="copyNewHandler"
              >{{ $t('SeaExport.copyAndAddPoItems') }}</el-button>
              <el-button no="3" type="primary" :disabled="readonly||!addEnable" @click="addHandler">{{ $t('SeaExport.Add2') }}</el-button>
              <el-button no="4" type="danger" :disabled="readonly" @click="delHandler">{{ $t('SeaExport.Delete') }}</el-button>
            </div>
          </div>
        </div>
        <el-divider v-if="job.multipleDischargingPickups" />
        <el-form :inline="true" class="inline-form" label-width="100px" label-position="left">
          <el-form-item>
            <template slot="label">
              <el-checkbox
                v-model="job.multipleDischargingPickups"
                no="5.1"
                :disabled="readonly || action==='add'"
                @change="multiPickupsChangeHandler"
              >
                {{ $t('SeaExport.MultiDoors') }}
              </el-checkbox>
            </template>
          </el-form-item>
        </el-form>
        <el-form :inline="true" class="inline-form" label-width="100px" label-position="left">
          <el-form-item>
            <label style="width: 55px">{{ $t('SeaExport.Quantity') }}</label>
            <el-input-number
              no="6"
              :value="truckingInfo.quantity||undefined"
              :disabled="readonly"
              :min="0"
              :max="99999"
              :precision="0"
              controls-position="right"
              style="width: 118px"
              @input="val=>{truckingInfo.quantity=val}"
            />
            <label style="width: 55px">{{ $t('SeaExport.Weight') }}</label>
            <el-input-number
              no="7"
              :value="truckingInfo.weight||undefined"
              :disabled="readonly"
              :min="0"
              :max="99999"
              :precision="3"
              controls-position="right"
              style="width: 118px"
              @input="val=>{truckingInfo.weight=val}"
            />
            <label style="width: 55px">{{ $t('SeaExport.Cubage') }}</label>
            <el-input-number
              no="8"
              :value="truckingInfo.cubage||undefined"
              :disabled="readonly"
              :min="0"
              :max="99999"
              :precision="3"
              controls-position="right"
              style="width: 118px"
              @input="val=>{truckingInfo.cubage=val}"
            />
          </el-form-item>
          <el-form-item v-if="job.multipleDischargingPickups" label="S/O No" label-width="100px" class="custom" style="margin-left: 30px;">
            <so-no-selector v-model="truckingInfo.soNo" :so-no="soNo" :disabled="readonly" style="width:400px" />
          </el-form-item>
        </el-form>
        <div class="trucking-form">
          <el-form :disabled="readonly" label-width="140px" label-position="left">
            <el-form-item v-if="!isSalesForSzfs" :label="$t('SeaExport.HaulageCompany')" class="custom">
              <cargo-company-select
                no="9"
                :disabled="readonly"
                :method-params="{truckCmp:true,active:true}"
                :default-value="truckingInfo.carryingCmp||''"
                style="width:400px; display:inline-block"
                @change="p=>{truckingInfo.carryingCmp=p.value||0;carryingCmpChangeHandler()}"
              />
            </el-form-item>
            <el-form-item v-if="!isSalesForSzfs" :label="$t('SeaExport.HaulageContactPerson')" class="custom">
              <el-select
                v-model="truckingInfo.driver"
                no="10"
                style="width:400px"
                :placeholder="readonly ? '' : $t('CargoMsg.Cargo_PleaseSelect')"
                :allow-create="true"
                :clearable="true"
                filterable
                @change="carryingContactsChangeHandler(false, false)"
                @blur="selectContactBlur"
              >
                <el-option
                  v-for="(item,index) in carryingContacts"
                  :key="index"
                  :label="item.contactPerson"
                  :value="item.contactPerson"
                />
              </el-select>
            </el-form-item>
            <el-form-item class="custom" :label="$t('CargoMsg.EstimatedDeliveryDate')">
              <el-date-picker
                ref="loadingDate"
                v-model="truckingInfo.loadingDate"
                no="11"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                style="width:400px"
                @blur="()=> { handleBlur('loadingDate', null, true, true, truckingInfo) }"
              />
            </el-form-item>
            <el-form-item v-if="!isSalesForSzfs" :label="$t('Warehouse.Driver')" :disabled="txtEditEable" class="custom">
              <el-input v-model="truckingInfo.driverName" no="12" style="width:400px;" />
            </el-form-item>
            <el-form-item class="custom" :label="$t('SeaExport.travelTime')">
              <el-input-number v-model="truckingInfo.travelHour" no="13" :min="0" controls-position="right" style="width:105px" />
              <span style="margin:10px">{{ $t('SeaExport.Hour') }}</span>
              <el-input-number
                v-model="truckingInfo.travelMinute"
                no="14"
                :min="0"
                :max="59"
                controls-position="right"
                style="width:100px"
              />
              <span style="margin:10px">{{ $t('SeaExport.Minute') }}</span>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DoorContactPerson')" class="custom">
              <el-input v-model="truckingInfo.doorMan" no="15" style="width:400px" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DoorAddress')" class="custom">
              <el-input v-model="truckingInfo.doorAddr" no="16" type="textarea" :rows="3" style="width:400px" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ZIP')" class="custom">
              <el-input v-model="truckingInfo.zipCode" no="zipCode" style="width:400px" />
            </el-form-item>
            <el-form-item class="auto-width" label-width="0">
              <div style="display: flex;">
                <el-form-item class="custom" :label="$t('Pricing.BelongingCity')">
                  <cargo-advance-select
                    no="17"
                    style="width:160px"
                    :disabled="readonly"
                    :tag-name="$store.getters.language === 'zh' ? 'chineseName' : 'englishName'"
                    tag-value="code"
                    :cache="false"
                    filterable
                    :default-value="truckingInfo.cityCode"
                    :static-options="cityList"
                    :placeholder="$t('SeaExport.PleaseSelect')"
                    @parentCallBack="p=>{truckingInfo.cityCode=p.value}"
                  />
                </el-form-item>
                <el-form label-width="100px" label-position="left">
                  <el-form-item class="custom" :label="$t('Warehouse.PalletSum')">
                    <el-input-number
                      no="18"
                      style="width:140px;"
                      :value="truckingInfo.palletSum"
                      :disabled="readonly"
                      :min="0"
                      :max="999999999999"
                      :precision="0"
                      :controls="false"
                      @input="val=>{truckingInfo.palletSum=val || 0}"
                    />
                  </el-form-item>
                </el-form>
              </div>
            </el-form-item>
            <el-form-item class="custom" :label="$t('CargoMsg.Cargo_PalletDetails')">
              <cargo-textarea v-model="truckingInfo.palletDetail" no="agentInformation" type="textarea" :row="3" style="width:400px" />
            </el-form-item>
            <el-form-item class="custom" :label="$t('CargoMsg.Cargo_PalletDimensions')">
              <cargo-textarea v-model="truckingInfo.palletSize" no="agentInformation" type="textarea" :row="3" style="width:400px" />
            </el-form-item>
            <el-form-item label="PO">
              <el-input
                v-model="truckingInfo.po"
                no="po"
                :disabled="readonly"
                :filter-chars="false"
                type="textarea"
                :rows="3"
                style="width:400px"
              />
            </el-form-item>
            <el-form-item v-if="!isSalesForSzfs" :label="$t('SeaExport.BillExchangeAgent')">
              <cargo-company-select
                no="exChangeAgent"
                :method-params="{bookingAgent:true,active:true}"
                :default-value="truckingInfo.exChangeAgent||''"
                style="width:400px;display:inline-block"
                @change="onExChangeAgentChange"
              />
            </el-form-item>
          </el-form>
          <el-form label-width="100px" label-position="left">
            <el-form-item class="custom" :label="$t('SeaExport.HaulageNo')">
              <el-input
                v-model="truckingInfo.truckOrderNo"
                no="19"
                :disabled="readonly || !!truckingInfo.carFormUuid"
                style="width:158px"
                @change="checkTruckOrderNo();refreshTopGrid()"
              />
            </el-form-item>
            <el-form-item class="custom" :label="$t('SeaExport.HaulageCharge')">
              <div style="display: flex;">
                <el-input-number
                  no="40"
                  :value="truckingInfo.truckingFee"
                  :disabled="readonly"
                  :min="0"
                  :max="999999999999"
                  :precision="2"
                  controls-position="right"
                  style="width:117px"
                  @input="value=>{truckingFeeCharge(value||0)}"
                />
                <cargo-advance-select
                  no="currency"
                  :disabled="readonly"
                  :select-type="TYPE_NAMES.basic_data_Currency"
                  filterable
                  :clearable="false"
                  :default-value="truckingInfo.currency"
                  style="width:74px;margin-left:5px"
                  @parentCallBack="onCurrencyChange"
                />
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DestinationPortAdditionalFee')" class="custom">
              <el-input
                v-model="truckingInfo.destinationPortAdditionalFee"
                no="destinationPortAdditionalFee"
                :disabled="readonly"
                type="textarea"
                :rows="3"
                style="width:400px"
              />
            </el-form-item>
            <el-form-item v-if="!isSalesForSzfs" class="custom" :label="$t('SeaExport.Tel')">
              <el-input v-model="truckingInfo.driverTel" no="41" :disabled="readonly" style="width:400px" @change="refreshTopGrid" />
            </el-form-item>
            <el-form-item class="custom" :label="$t('CargoMsg.ActualDeliveryDate')">
              <el-date-picker
                ref="actLoadingDate"
                v-model="truckingInfo.actLoadingDate"
                no="42"
                :disabled="readonly"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                style="width:400px"
                @blur="()=> { handleBlur('actLoadingDate', null, true, true, truckingInfo) }"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PlateNumber')" class="custom">
              <el-input
                v-if="isEdit"
                v-model="truckingInfo.plateNumber"
                no="43"
                style="width:280px;"
                @input="(val)=>{truckingInfo.plateNumber = val.trim()}"
              />
              <span v-if="readonly" class="plate_number">{{ truckingInfo.plateNumber }}</span>
            </el-form-item>
            <el-form-item v-if="!isSalesForSzfs" :label="$t('Warehouse.DriverPhone')" :disabled="txtEditEable" class="custom">
              <el-input v-model="truckingInfo.driverPhone" no="45" :disabled="readonly" style="width:400px;" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Door')" class="custom">
              <cargo-repeat-value-select
                v-model="truckingInfo.doorName"
                :placeholder="readonly ? '' : $t('CargoMsg.Cargo_PleaseSelect')"
                filterable
                :allow-create="true"
                :disabled="readonly"
                clearable
                :options="doorList"
                label-field="name"
                value-field="name"
                unique-field="uuid"
                :match-of-repeat-value="matchOfRepeatDoor"
                style="width: 400px"
                @change="doorsChangeHandler"
              />
            </el-form-item>
            <el-form-item class="custom" :label="$t('SeaExport.Tel')">
              <el-input v-model="truckingInfo.doorManTel" no="46" :disabled="readonly" style="width:400px" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.AdditionalNotes')">
              <el-input
                v-model="truckingInfo.remarks"
                no="47"
                :disabled="readonly"
                :filter-chars="false"
                type="textarea"
                :rows="3"
                style="width:400px"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.DischargingWay')">
              <el-select
                :value="truckingInfo.dischargingWay?truckingInfo.dischargingWay.split(','):[]"
                no="48"
                :disabled="readonly"
                multiple
                style="width:400px"
                @input="value=>{truckingInfo.dischargingWay=value.join(',')}"
              >
                <el-option value="DROP" />
                <el-option value="LIVE UNLOAD" />
                <el-option value="EXCHANGE PALLETS" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.LatestDeliveryDate')">
              <el-date-picker
                ref="actDeliveryDate"
                v-model="truckingInfo.actDeliveryDate"
                no="actDeliveryDate"
                :disabled="readonly"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                style="width:400px"
                @blur="()=> { handleBlur('actDeliveryDate', null, true, true, truckingInfo) }"
              />
            </el-form-item>
            <el-form-item :label="$t('RailwayExport.EQQuantity')">
              <el-input
                v-model="truckingInfo.boxesNumber"
                type="text"
                no="61"
                :disabled="readonly"
                style="width:400px"
                @input="truckingInfo.boxesNumber = truckingInfo.boxesNumber.replace(/[^0-9]/g, '')"
              />
            </el-form-item>
          </el-form>
        </div>
      </div>

      <!--      远程订舱排除掉这个列表-->
      <div v-show="pageSource !== 'remoteBooking'">
        <div v-if="!isMaster" class="app-main-inner-row operations">
          <div v-show="cooperateEdit" class="triggers">
            <div>
              <el-button
                no="48"
                type="primary"
                :disabled="!linkUsageEnable"
                @click="linkUsageClickHandler"
              >{{ $t('SeaExport.AddPackingInfo') }}</el-button>
              <el-button
                no="49"
                type="danger"
                :disabled="!linkUsageEnable"
                @click="delLinkUsageClickHandler"
              >{{ $t('SeaExport.RemovePackingInfo') }}</el-button>
            </div>
          </div>
        </div>
        <div style="flex-grow:1;padding:10px">
          <cargo-ag-grid
            no="52"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="usages"
            style="width:100%;height:350px"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
      </div>
    </div>
    <!-- 选择装箱信息弹窗 -->
    <discharging-trucking-container-usage-link-dialog
      :visible.sync="containerUsageDialog.visible"
      :job-uuid="job.uuid"
      :trucking-info-uuid="truckingInfo.uuid"
      :serial-nos="containerUsageDialog.serialNos"
      @selectContainerUsageHandler="selectContainerUsageHandler"
    />
    <!-- 附件 -->
    <upload-common-file :visible.sync="uploadCommonFileDialog.visible" :model="uploadCommonFileDialog.model" />
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import CargoDateTimeFieldInput from '@/components/Cargo/Common/cargoDateTimeFieldInput'
import cargoRepeatValueSelect from '@/components/Cargo/Common/cargoRepeatValueSelect'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index'
import SoNoSelector from '@/components/Cargo/Job/soNoSelector'
import DischargingTruckingContainerUsageLinkDialog from '@/components/Cargo/Job/dischargingTruckingContainerUsageLinkDialog'
import UploadCommonFile from '@/components/Cargo/Job/uploadCommonFile'
import moment from 'moment'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { TabError } from '@/utils/class/TabError'
import { cache, cacheName } from '@/utils/cacheManager'
import StrUtils from '@/utils/StrUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { DocumentManage, ensureExecuteSuccess, handleBlur } from '@/utils/commonUtil'
import * as NumberUtils from '@/utils/NumberUtils'
import DateUtils from '@/utils/dateUtils'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { DateAutoInitRuleManage } from '@/class/cargo/model/utils/DateAutoInitRuleManage'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { Job } from '@/class/model/booking/Job'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { DischargingTrucking } from '@/class/model/booking/DischargingTrucking'
import { Charge } from '@/class/model/act/Charge'
import { Company } from '@/class/model/mdm/Company'
import { batchDeleteDischargingTruckingContainerUsages, getDischargingTruckingContainerUsages, queryDischargingTruckingContainerUsageByJob, dischargingTruckingExportSyncImport } from '@/api/seaExport/dischargingTrucking'
import { addSites, getSites } from '@/api/company'
import { updateTrackingForDocumentType } from '@/api/fileHistory'
import { getLocationList } from '@/api/location'
import { queryJobNoLinkFunc } from '@/api/booking/job'
import { ChargeItem } from '@/class/model/mdm/chargeItem'
import { PrintTemplateUtil } from '@/class/cargo/model/utils/PrintTemplateUtil'
import cargoTextarea from '@/components/Cargo/Common/cargoTextarea.vue'

// 26字母
const LETTERS = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']

export default {
  name: 'TabDischargingTrucking',
  components: {
    cargoTextarea,
    cargoAdvanceSelect,
    cargoCompanySelect,
    CargoDateTimeFieldInput,
    cargoRepeatValueSelect,
    SoNoSelector,
    DischargingTruckingContainerUsageLinkDialog,
    UploadCommonFile
  },
  props: {
    context: { type: Object, required: true },
    action: { type: String, required: true },
    showSync: { type: Boolean, default: false },
    pageSource: { type: String, default: '' },
    cooperateEdit: { type: Boolean, default: true }, // 能否修改
    isSalesForSzfs: { type: Boolean, default: false } // 深圳丰收销售专用
  },
  data() {
    return {
      handleBlur,
      TYPE_NAMES,
      currentUser: {},
      cityList: [],
      job: new Job().fillDefaultValue().getData(),
      truckingInfo: new DischargingTrucking().fillDefaultValue().getData(), // 初始化
      oldTruckintFee: 0,
      soNo: '',
      needReloadDriver: false, // 切换公司时, 重新读取司机信息, 否则不读取
      neednotReloadTelephone: false, // 表格内切换门点时, 不按照联系人名称重新读取电话
      txtEditEable: false, // 编辑文本框是否允许编辑
      carryingContacts: [],
      doorList: [],
      matchOfRepeatDoor: options => {
        const option = options.find(p => p.contact === this.truckingInfo.doorMan)
        return option || options[0]
      },
      containerUsages: [], // 记录装箱明细，修改的拖车费
      top: {
        visible: true,
        gridOptions: {
          frameworkComponents: {
            CargoAgGridCommonInputEditor
          },
          rowSelection: 'single',
          singleClickEdit: true,
          suppressCellSelection: true,
          suppressRowClickSelection: true,
          suppressCopyRowsToClipboard: true,
          context: {
            componentParent: this
          },
          // 单选（勾选框或者其他列，都会触发）
          onCellFocused: (event) => {
            const nodes = event.api.rowModel.rowsToDisplay
            this.topSelectedNode = nodes[event.rowIndex] || null
          },
          onRowClicked: this.selectionChangeHandler,
          onSortChanged: event => {
            if (this.topSelectedNode) {
              event.api.setFocusedCell(this.topSelectedNode.rowIndex, event.columnApi.getAllDisplayedColumns()[0])
            }
          }
        }
      },
      trucking: [],
      topSelectedNode: null,
      topGridApi: null,
      delTruckingInfoUuids: [], // 记录删除的uuid
      addEnable: false,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      usages: [],
      gridApi: null,
      containerUsageDialog: {
        visible: false,
        serialNos: []
      },
      uploadCommonFileDialog: {
        visible: false,
        model: {}
      },
      documentManage: new DocumentManage()
    }
  },
  computed: {
    isMaster() {
      return this.job.masterFlag
    },
    readonly() {
      if (!this.cooperateEdit) return true
      return this.isMaster || this.action === 'look'
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return !this.isMaster && this.action !== 'look'
    },
    topConfigModuel() {
      if (this.job.lob === 'SE') {
        return this.isMaster ? '130138' : '130139'
      } else if (this.job.lob === 'AE') {
        return this.isMaster ? '130140' : '130141'
      }
      return ''
    },
    topColumnDefs() {
      const result = [
        {
          headerName: this.$t('SeaExport.HaulageCompany'),
          field: 'carryingCmp',
          colId: 'carryingCmp',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          },
          initialHide: this.isSalesForSzfs,
          suppressColumnsToolPanel: this.isSalesForSzfs,
          lockVisible: true
        },
        {
          headerName: this.$t('SeaExport.HaulageNo'),
          field: 'truckOrderNo',
          colId: 'truckOrderNo',
          width: 150
        },
        {
          headerName: this.$t('SeaExport.Door'),
          field: 'doorName',
          colId: 'doorName',
          width: 150
        },
        {
          headerName: this.$t('SeaExport.ContactPerson'),
          field: 'driver',
          colId: 'driver',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.Tel'),
          field: 'driverTel',
          colId: 'driverTel',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.ContainerNo'),
          field: 'containerNo',
          colId: 'containerNo',
          width: 120,
          hide: true
        },
        {
          headerName: this.$t('SeaExport.Quantity'),
          field: 'quantity',
          colId: 'quantity',
          width: 100,
          hide: true
        },
        {
          headerName: this.$t('SeaExport.Weight'),
          field: 'weight',
          colId: 'weight',
          width: 100,
          hide: true
        },
        {
          headerName: this.$t('SeaExport.Cubage'),
          field: 'cubage',
          colId: 'cubage',
          width: 100,
          hide: true
        },
        {
          headerName: this.$t('SeaExport.DoorAddress'),
          field: 'doorAddr',
          colId: 'doorAddr',
          width: 200,
          hide: true
        },
        {
          headerName: this.$t('SeaExport.AdditionalNotes'),
          field: 'remarks',
          colId: 'remarks',
          width: 200,
          hide: true
        },
        {
          headerName: this.$t('CargoMsg.DischargingWay'),
          field: 'dischargingWay',
          colId: 'dischargingWay',
          width: 150,
          hide: true
        },
        {
          headerName: this.$t('CargoMsg.LatestDeliveryDate'),
          field: 'actDeliveryDate',
          colId: 'actDeliveryDate',
          width: 150,
          hide: true,
          valueFormatter: params => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        }
      ]
      if (this.isMaster) {
        result.push({
          headerName: this.$t('SeaExport.ConsignationCompany'),
          field: 'customerId',
          width: 200,
          valueFormatter: params => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_0') : ''
          }
        }, {
          headerName: this.$t('SeaExport.ContainerSerialNo'),
          field: 'serialNo',
          width: 120,
          editable: params => this.action !== 'look',
          cellEditor: 'CargoAgGridCommonInputEditor'
        })
      }
      return result
    },
    columnDefs() {
      return [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('SeaExport.ContainerSize'),
          field: 'eqSize',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.containerUsageFiledLabelFunction(params.data, 'eqSize')
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerType'),
          field: 'eqType',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.containerUsageFiledLabelFunction(params.data, 'eqType')
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerNo'),
          field: 'containerNo',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.containerUsageFiledLabelFunction(params.data, 'containerNo')
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerWeight'),
          field: 'containerWeight',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.containerUsageFiledLabelFunction(params.data, 'containerWeight')
          }
        },
        {
          headerName: this.$t('SeaExport.SealNo'),
          field: 'sealNo',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.containerUsageFiledLabelFunction(params.data, 'sealNo')
          }
        },
        {
          headerName: this.$t('SeaExport.Quantity'),
          field: 'quantity',
          width: 110,
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Weight'),
          field: 'weight',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Cubage'),
          field: 'cubage',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.HaulageCharge'),
          field: 'truckingFee',
          width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'el-input-number',
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        {
          headerName: this.$t('SeaExport.AuditMoney'),
          field: 'auditMoney',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.TuckStatus'),
          field: 'truckStatus',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.truckingOrderLableFun(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.TuckStatusDescription'),
          field: 'description',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.truckingPlaceDep'),
          field: 'truckingPlaceOfDep',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.truckingPlaceDest'),
          field: 'truckingPlaceOfDest',
          width: 120
        },
        {
          headerName: this.$t('CargoMsg.Cargo_UploadAttachment'),
          field: 'uuid',
          width: 120,
          cellRenderer: params => {
            const uploadFileClickHandler = this.documentManage.getPath('uploadFileClickHandler')
            return `<a onclick="${uploadFileClickHandler}('${params.value}')" style="color:blue">${this.$t('CargoMsg.Cargo_Attachment')}</a>`
          }
        },
        {
          headerName: this.$t('SeaExport.AuditState'),
          field: 'auditState',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.costStatusLableFun(params.data, 'auditState')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ConfirmExpenses'),
          field: 'auditUrl',
          width: 120,
          cellRenderer: params => {
            if (params.data.auditUrl && !params.data.auditState) {
              const auditUrlClickHandler = this.documentManage.getPath('auditUrlClickHandler')
              return `<a onclick="${auditUrlClickHandler}('${params.value}')" style="color:blue">${this.$t('CargoMsg.Cargo_ConfirmExpenses')}</a>`
            } else return ''
          }
        },
        {
          headerName: this.$t('SeaExport.HLID'),
          field: 'dcSequence',
          width: 120,
          cellRenderer: (params) => {
            if (!StrUtils.isEmpty(params.data.dcTicketNo) && !StrUtils.isEmpty(params.data.dcSequence)) {
              return params.data.dcTicketNo + '_' + params.data.dcSequence
            } else {
              return params.data.dcSequence
            }
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerNoDiff'),
          field: 'containerNoDiff',
          width: 120,
          headerClass: 'red',
          cellStyle: { color: 'red!important' }
        },
        {
          headerName: this.$t('SeaExport.DriverNameHL'),
          field: 'driverNameHL',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.DriverPhoneHL'),
          field: 'driverPhoneHL',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.TruckNoHL'),
          field: 'truckNoHL',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.ContainerSerialNo'),
          field: 'serialNo',
          width: 120
        }
      ]
    },
    linkUsageEnable() {
      return this.readonly && this.job.dischargingTrucking && this.job.dischargingTrucking.length > 0 && this.truckingInfo.uuid
    }
  },
  watch: {
    topConfigModuel() {
      this.top.visible = false
      this.$nextTick(() => {
        this.top.visible = true
      })
    }
  },
  created() {
    getLocationList().then((res) => {
      this.cityList = res.data.list || []
    })
  },
  beforeMount() {
    const self = this
    this.documentManage.set('uploadFileClickHandler', function(value) {
      self.uploadFileClickHandler(value)
    })
    this.documentManage.set('auditUrlClickHandler', function(value) {
      self.auditUrlClickHandler(value)
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    async onShow(row, isRefresh) {
      this.job = row
      this.loadSites()
      if (!isRefresh) {
        return
      }
      await cache.load(cacheName.USER, cacheName.CONFIG)
      this.currentUser = cache.user
      await this.startLoad()
      await this.autoCalculateDateRule()
      this.checkTruckOrderNo()
      this.containerUsages = []
    },
    async exportSyncImport() {
      const loading = getLoading4Cxt(this)
      try {
        // 是否正操作状态
        let isOperating = this.job.jobState === SystemConstants.STATE_OPERATING.code
        if (isOperating) {
          await queryJobNoLinkFunc({ jobNo: this.job.relatedJob }).then(res => {
            const data = res.data
            if (data.jobState !== SystemConstants.STATE_OPERATING.code) {
              isOperating = false
              return
            }
            if (data.lclList && data.lclList.length > 0) {
              for (const item of data.lclList) {
                if (item.jobState !== SystemConstants.STATE_OPERATING.code) {
                  isOperating = false
                  return
                }
              }
            }
          })
        }
        if (!isOperating) {
          this.$message.warning(this.$t('queryJob.NotOperatingCannotSynchronized'))
          return
        }
        // 进口是否已同步过
        if (this.trucking.findIndex(p => p.relatedTrucking) > -1 || this.truckingInfo.relatedTrucking) {
          const isContinues = await this.$confirm(
            this.$t('queryJob.ImportHasSynchronizedDispatchingInformation'),
            this.$t('Message.Prompt'), {
              confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
              cancelButtonText: this.$t('common.btn.cancel'),
              dangerouslyUseHTMLString: true,
              showClose: false,
              closeOnClickModal: false,
              type: 'warning'
            }
          ).then(() => true).catch(() => false)
          if (!isContinues) {
            return
          }
        }
        await dischargingTruckingExportSyncImport({ jobKey: this.job.uuid }).then(() => {
          this.$message.success(this.$t('Message.SynchronizationSucceeded'))
        })
      } finally {
        loading.close()
      }
    },
    // 门店地址
    loadSites() {
      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.job.customerId))
      if (!companyCache) return
      const companyUuid = companyCache.uuid
      if (!companyUuid) return
      getSites(companyUuid).then(res => {
        this.doorList = res.data
      })
    },
    // 加载数据
    async startLoad() {
      if (this.readonly) {
        const jobModel = new SeaExportJob(this.job)
        jobModel.dischargingTrucking = ''
        jobModel.charges = ''
        await Promise.all([
          jobModel.getDischargingTrucking(),
          jobModel.getCharges()
        ])
      }
      const trucking = this.sortTrucking(this.job.dischargingTrucking)
      this.setContainerNo(trucking)
      if (trucking.length > 0) {
        this.truckingInfo = trucking[0]
      } else {
        this.setDefaultTrucking()
      }
      if (this.isMaster) {
        this.job.multipleDischargingPickups = trucking.length > 1
      }
      if (this.job.multipleDischargingPickups) {
        this.trucking = trucking
        if (this.trucking.length > 0) {
          this.$nextTick(async() => {
            // 等待topGridApi被赋值
            await ensureExecuteSuccess(() => this.topGridApi)
            this.setGridSelect()
          })
        }
      } else {
        this.trucking = []
        this.selectionChangeHandler({ data: this.truckingInfo })
      }
    },
    sortTrucking(trucking) {
      const newTrucking = [...trucking]
      return newTrucking.sort((a, b) => {
        if (a > b) {
          return 1
        } else if (a === b) {
          return 0
        } else {
          return -1
        }
      })
    },
    setContainerNo(trucking) {
      if (trucking.length === 0) {
        return
      }
      const truckingKeys = []
      for (const item of trucking) {
        if (item.uuid) {
          truckingKeys.push(item.uuid)
        }
      }
      if (truckingKeys && truckingKeys.length > 0) {
        queryDischargingTruckingContainerUsageByJob({ truckingKeys: truckingKeys.join(',') }).then(res => {
          const containerUsageMap = new Map()
          if (this.job.masterFlag) {
            if (this.job.containers) {
              for (const container of this.job.containers) {
                if (container.containerUsage) {
                  for (const item of container.containerUsage) {
                    containerUsageMap.set(item.uuid, item)
                  }
                }
              }
            }
          } else {
            if (this.job.containerUsages) {
              for (const item of this.job.containerUsages) {
                containerUsageMap.set(item.uuid, item)
              }
            }
          }
          // 门点箱号映射
          const tuckingContainNoMap = new Map()
          for (const item of res.data) {
            const containerUsage = containerUsageMap.get(item.containerUsageUuid)
            if (!containerUsage) {
              continue
            }
            let containerNo = tuckingContainNoMap.get(item.dischargingTruckingUuid)
            if (containerNo) {
              if (containerUsage.containerNo) {
                containerNo += ',' + containerUsage.containerNo
              }
            } else {
              containerNo = containerUsage.containerNo
            }
            tuckingContainNoMap.set(item.dischargingTruckingUuid, containerNo)
          }
          for (const item of trucking) {
            item.containerNo = tuckingContainNoMap.get(item.uuid) || ''
          }
          this.refreshTopGrid()
        })
      }
    },
    setDefaultTrucking() {
      this.truckingInfo = new DischargingTrucking().fillDefaultValue().getData()
      this.truckingInfo.dischargingPortService = true
      this.truckingInfo.exChangeAgent = this.job.exChangeAgent
      this.truckingInfo.currency = 'USD'
      this.truckingInfo.quantity = this.job.quantityActual
      this.truckingInfo.weight = this.job.weightActual
      this.truckingInfo.cubage = this.job.cubageActual
      this.truckingInfo.truckOrderNo = this.createTruckOrderNo()
      if (this.isEdit) {
        this.truckingInfo.jobUuid = this.job.uuid
        if (!this.job.multipleDischargingPickups) {
          if (!this.job.dischargingTrucking) {
            this.job.dischargingTrucking = []
          }
          this.job.dischargingTrucking.push(this.truckingInfo)
        }
      }
    },
    // 派车单号生成
    createTruckOrderNo() {
      const job = this.job
      if (!job.uuid) {
        return ''
      }
      let maxIndex = -1
      for (const item of this.trucking) {
        const suffix = item.truckOrderNo.replace(`${job.jobNo}_`, '')
        const index = LETTERS.indexOf(suffix)
        if (index >= 0 && index > maxIndex) {
          maxIndex = index
        }
      }
      if (maxIndex + 1 < LETTERS.length) {
        return job.jobNo + '_' + LETTERS[maxIndex + 1]
      }
      return ''
    },
    checkTruckOrderNo() {
      this.addEnable = !!this.createTruckOrderNo()
    },
    async autoCalculateDateRule() {
      await DateAutoInitRuleManage.getInstance().autoCalculateDateRule(this.job, this.truckingInfo, 'SE')
    },
    // 设置选中行
    setGridSelect(rowIndex = 0) {
      const nodes = this.topGridApi.rowModel.rowsToDisplay
      const seletedNode = nodes[rowIndex]
      if (seletedNode) {
        this.topGridApi.setFocusedCell(rowIndex, this.topGridApi.columnController.getAllDisplayedColumns()[0])
        this.selectionChangeHandler({ data: seletedNode.data })
      }
    },
    selectionChangeHandler({ data }) {
      this.truckingInfo = data
      this.neednotReloadTelephone = true
      this.txtEditEable = this.isEdit && (this.truckingInfo.sendState === 0)
      this.carryingCmpRelatedHandler()
      this.filterSONo()
      this.loadTruckingInfoUsage(this.truckingInfo)
      this.resetColumnState()
    },
    // 过滤S/O No
    filterSONo() {
      this.soNo = ''
      if (this.job.lob === 'SE') {
        if (this.isEdit) {
          const soNos = this.job.soNo == null ? [] : this.job.soNo.split('\n')
          const len = soNos.length
          for (let i = len - 1; i >= 0; i--) {
            const s = soNos[i]
            for (const truck of this.job.dischargingTrucking) {
              if (truck === this.truckingInfo) {
                continue
              }
              let isIn = false
              if (truck.soNo && truck.soNo.length > 0) {
                const ts = truck.soNo.split('\n')
                for (const t of ts) {
                  if (t === s) {
                    isIn = true
                    soNos.splice(i, 1)
                    break
                  }
                }
              }
              if (isIn) {
                break
              }
            }
          }
          this.soNo = soNos.join('\n')
        } else if (this.truckingInfo) {
          this.soNo = this.truckingInfo.soNo
        }
      }
    },
    loadTruckingInfoUsage(truckingInfo) {
      if (truckingInfo.uuid) {
        getDischargingTruckingContainerUsages({ truckingKey: truckingInfo.uuid }).then(res => {
          this.usages = res.data
        })
      } else {
        this.usages = []
      }
    },
    resetColumnState() {
      for (const item of this.columnDefs) {
        if (item.custom instanceof Object) {
          item.custom.isEdit = this.isEdit
        }
      }
    },
    // 复制新增
    copyNewHandler() {
      if (this.trucking.length === 0) {
        this.$message.warning('SeaExport.PleaseSelectData')
        return
      }
      this.fillModel()
      const item = this.truckingInfo
      if (this.validate()) {
        const trucking = new DischargingTrucking().fillDefaultValue().getData()
        trucking.jobUuid = this.job.uuid
        this.copyBasic(trucking, item)
        trucking.loadingDate = item.loadingDate
        trucking.actLoadingDate = item.actLoadingDate
        trucking.cubage = item.cubage
        trucking.plateNumber = item.plateNumber
        trucking.loadingPortService = item.loadingPortService
        trucking.dischargingPortService = item.dischargingPortService
        trucking.dischargingWay = item.dischargingWay
        trucking.po = item.po
        trucking.zipCode = item.zipCode
        trucking.exChangeAgent = item.exChangeAgent
        trucking.currency = item.currency
        trucking.truckOrderNo = this.createTruckOrderNo()
        // 复制新增时，派车单号和拖车费不复制
        trucking.truckingFee = 0.00
        this.trucking.push(trucking)
        this.job.dischargingTrucking.push(trucking)
        this.checkTruckOrderNo()
        this.$nextTick(() => {
          this.setGridSelect(this.trucking.length - 1)
        })
      }
    },
    fillModel() {
      const door = this.doorList.find(item => item.name === this.truckingInfo.doorName)
      if (!door) {
        this.newDoor()
      }
      if (!this.job.multipleDischargingPickups) {
        this.truckingInfo.soNo = ''
      }
      this.createCharge(false)
    },
    newDoor() {
      if (!this.job.customerId) {
        return
      }
      if (!this.truckingInfo.doorName) {
        return
      }
      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.job.customerId))
      const door = {
        name: this.truckingInfo.doorName,
        contact: this.truckingInfo.doorMan,
        phone: this.truckingInfo.doorManTel,
        address: this.truckingInfo.doorAddr,
        companyUuid: companyCache.uuid
      }
      addSites(door)
    },
    async createCharge(isFinal, source) {
      if (!this.truckingInfo.truckingFee && this.truckingInfo.truckingFee !== 0) {
        this.$nextTick(() => {
          this.truckingInfo.truckingFee = 0
        })
      }
      if (!isFinal) {
        return
      }
      const chargeCount = this.getCost()
      const amount = this.truckingInfo.truckingFee
      const truckingCount = this.job.dischargingTrucking ? this.job.dischargingTrucking.length : 0
      let charge = null
      let isCreate = true
      if (this.job.charges && this.job.charges.length > 0) {
        for (const c of this.job.charges) {
          if (c.truckOrderNo === this.truckingInfo.truckOrderNo) {
            isCreate = false
            charge = c // 先录费用后录拖车使用
            break
          }
        }
      }
      const chargeItemId = parseInt(cache.config.get('TruckingFeeCode'))
      const chargeItem = ChargeItem.getChargeItemById(chargeItemId)
      if (chargeItem && chargeItem.active && truckingCount > chargeCount && amount > 0 && isCreate) {
        charge = this.createNewCharge()
        charge.truckOrderNo = this.truckingInfo.truckOrderNo
        charge.chargeItemId = chargeItemId
        if (!this.job.charges) {
          this.job.charges = []
        }
        charge.serialNumber = this.job.charges.filter(p => !p.receivable).length + 1
        charge.isDirty = true
        this.job.charges.push(charge)
      }
      if (charge && charge.verifiedAmount === 0 && StrUtils.isEmpty(charge.billingUuid) && StrUtils.isEmpty(charge.billingPaymentUuid) && StrUtils.isEmpty(charge.invoiceUuid)) {
        const shared = charge.shared || (charge.shareScheme && parseInt(charge.shareScheme) !== 0) // 是否已分摊
        if (!isNaN(amount) && amount > 0) {
          charge.accountId = this.truckingInfo.carryingCmp
          if (charge.uuid) {
            if (charge.chargeState === 0 && !charge.confirmState && !this.job.payableChargeLockedStatus && !shared) {
              charge.unitRate = amount
            } else {
              if (!(await this.truckingFeeConfirm(source))) {
                return
              }
            }
          } else {
            charge.unitRate = amount
          }
          charge.currency = this.truckingInfo.currency
          const localCurrency = RateUtil.localCurrencyByOfficeId(charge.branchId)
          if (charge.currency !== localCurrency) {
            await RateUtil.getForeignExchangeRateByJob(localCurrency, charge.currency, this.job, charge.branchId).then(value => {
              charge.exchangeRate = value
            })
          } else {
            charge.exchangeRate = 1
          }
          const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.truckingInfo.carryingCmp))
          let taxRate = 0
          if (companyCache && companyCache.taxRate !== 0 && String(companyCache.taxRate) !== 'NaN') {
            taxRate = companyCache.taxRate
          }
          charge.taxRate = taxRate
          ChargeUtils.calculateTax(charge, parseFloat((charge.unitRate * charge.quantity).toFixed(2)), taxRate)
          charge.isDirty = true
        } else {
          if (!shared && !(await this.truckingFeeConfirm(source))) {
            return
          }
        }
      }
      // 设置开票抬头
      if (charge && charge.accountId && charge.accountId > 0) {
        await ChargeUtils.updateDefaultInvoiceTitle([charge])
        this.$logger.log('invoiceTitle=============', charge.invoiceTitle)
      }
      this.context.reloadCharge = true
    },
    getCost() {
      // TRUCKING_FEE_CODE 默认拖车费
      const chargeCode = parseInt(cache.config.get('TruckingFeeCode'))
      let count = 0
      for (const charge of this.job.charges) {
        if (charge.chargeItemId === chargeCode && !charge.receivable) {
          count++
        }
      }
      return count
    },
    createNewCharge() {
      const charge = new Charge().fillDefaultValue().getData()
      charge.jobUuid = this.job.uuid
      charge.businessDate = this.job.businessDate
      charge.quantity = 1
      charge.currency = this.truckingInfo.currency
      charge.measure = 'NML'
      charge.receivable = false
      charge.oversea = false
      charge.verifiedAmount = 0
      charge.inputDate = DateUtils.formatStandardDateTime(new Date())
      charge.inputBy = this.currentUser.userId
      charge.branchId = this.$store.getters.currentOfficeId
      const localCurrency = RateUtil.localCurrencyByOfficeId(charge.branchId)
      charge.localCurrency = localCurrency
      charge.inputByDep = this.job.opDepartment
      charge.businessDate = this.job.businessDate
      // 此处增加标识，费用页签再保存会导致费用重复生成
      charge.createdByOther = true
      return charge
    },
    async truckingFeeConfirm(source) {
      if (this.job.lob === 'SE' && source === 'truckingFee') {
        const flag = await this.$confirm(this.$t('SeaExport.IfToTheCurrentIt'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('constant.yes'),
          cancelButtonText: this.$t('constant.no'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => true).catch(() => false)
        if (!flag) {
          this.truckingInfo.truckingFee = this.oldTruckintFee
          return false
        }
      }
      return true
    },
    // 验证
    validate() {
      if (!this.truckingInfo.carryingCmp && this.truckingInfo.truckingFee) {
        this.$message.warning(this.$t('Message.PleaseEnterTheShippingCompanyInformation'))
        return false
      }
      return true
    },
    // 复制属性
    copyBasic(target, source) {
      target.carryingCmp = source.carryingCmp
      target.doorAddr = source.doorAddr
      target.doorMan = source.doorMan
      target.doorManTel = source.doorManTel
      target.doorName = source.doorName
      target.cubage = source.cubage
      target.quantity = source.quantity
      target.weight = source.weight
      target.remarks = source.remarks
      target.driver = source.driver
      target.driverTel = source.driverTel
    },
    // 新增
    addHandler() {
      this.fillModel()
      if (this.validate()) {
        const trucking = new DischargingTrucking().fillDefaultValue().getData()
        trucking.dischargingPortService = true
        trucking.exChangeAgent = this.job.exChangeAgent
        trucking.currency = 'USD'
        if (this.trucking.length === 0) {
          trucking.carryingCmp = this.job.carryingCmp
          trucking.quantity = this.job.quantityActual
          trucking.weight = this.job.weightActual
          trucking.cubage = this.job.cubageActual
        }
        trucking.jobUuid = this.job.uuid
        // 新增的时候门点也清空
        trucking.doorName = ''
        trucking.doorMan = ''
        trucking.doorManTel = ''
        trucking.doorAddr = ''
        trucking.truckOrderNo = this.createTruckOrderNo()
        this.trucking.push(trucking)
        this.job.dischargingTrucking.push(trucking)
        this.checkTruckOrderNo()
        this.$nextTick(() => {
          this.setGridSelect(this.trucking.length - 1)
        })
      }
    },
    // 删除
    delHandler() {
      if (this.truckingInfo && this.truckingInfo.carFormUuid) {
        this.$message.warning(this.$t('CargoMsg.Cargo_DispatchTaskLinkedToVehicle'))
        return
      }
      const index = this.trucking.indexOf(this.truckingInfo)
      if (index < 0) {
        return
      }
      if (this.truckingInfo.uuid && this.delTruckingInfoUuids.indexOf(this.truckingInfo.uuid) < 0) {
        this.delTruckingInfoUuids.push(this.truckingInfo.uuid)
      }
      this.trucking.splice(index, 1)
      const index2 = this.job.dischargingTrucking.indexOf(this.truckingInfo)
      if (index2 >= 0) {
        this.job.dischargingTrucking.splice(index2, 1)
      }
      this.checkTruckOrderNo()
      if (this.trucking.length > 0) {
        this.$nextTick(() => {
          this.setGridSelect()
        })
      } else {
        this.setDefaultTrucking()
        this.selectionChangeHandler({ data: this.truckingInfo })
      }
    },
    multiPickupsChangeHandler() {
      if (this.job.multipleDischargingPickups) {
        this.trucking = [this.truckingInfo]
        this.$nextTick(() => {
          this.setGridSelect()
        })
      } else {
        // 取消勾选多门点，除了当前记录外，其他都删除
        for (const item of this.trucking) {
          if (item === this.truckingInfo) {
            continue
          }
          if (item.uuid && this.delTruckingInfoUuids.indexOf(item.uuid) < 0) {
            this.delTruckingInfoUuids.push(item.uuid)
          }
        }
        this.trucking = []
        this.job.dischargingTrucking.splice(0, this.job.dischargingTrucking.length, this.truckingInfo)
      }
    },
    // 拖车费
    truckingFeeCharge(newVal) {
      if (typeof newVal !== 'undefined') {
        if (newVal === this.truckingInfo.truckingFee) {
          return
        }
        this.oldTruckintFee = this.truckingInfo.truckingFee
        this.truckingInfo.truckingFee = newVal
      }
      if (this.truckingInfo && this.isEdit) {
        this.createCharge(true, 'truckingFee')
      }
    },
    // 币种
    onCurrencyChange(data) {
      this.truckingInfo.currency = data.value
      if (this.truckingInfo && this.isEdit) {
        this.createCharge(true)
      }
    },
    doorsChangeHandler(value, option) {
      this.truckingInfo.doorMan = ''
      this.truckingInfo.doorManTel = ''
      this.truckingInfo.doorAddr = ''
      this.truckingInfo.zipCode = ''
      if (option) {
        this.truckingInfo.doorMan = option.contact
        this.truckingInfo.doorManTel = option.phone
        this.truckingInfo.doorAddr = option.address
        this.truckingInfo.zipCode = option.zipCode
        if (option.remarks) this.truckingInfo.remarks = option.remarks
      }
      this.refreshTopGrid()
    },
    refreshTopGrid() {
      this.topGridApi.refreshCells({ force: true })
    },
    // 运输公司
    async carryingCmpChangeHandler() {
      this.neednotReloadTelephone = false
      this.needReloadDriver = true
      this.truckingInfo.driver = ''
      this.truckingInfo.driverTel = ''
      this.carryingContacts = []
      await this.carryingCmpRelatedHandler()
      this.refreshTopGrid()
      this.truckingFeeCharge()
    },
    async carryingCmpRelatedHandler() {
      if (!this.truckingInfo.carryingCmp) {
        return
      }
      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.truckingInfo.carryingCmp))
      if (!companyCache) {
        this.truckingInfo.carryingCmp = 0
        this.isNullData()
        return
      }
      const company = new Company({ cmpIdx: this.truckingInfo.carryingCmp })
      if (!company) return
      this.carryingContacts = await company.getContactsBycmpIdx()

      if (this.carryingContacts && this.carryingContacts.length > 0) {
        if (!this.truckingInfo.driver) {
          this.truckingInfo.driver = this.carryingContacts[0].contactPerson
        }
      } else {
        this.isNullData()
      }
      if (!this.truckingInfo.driver) return
      this.carryingContactsChangeHandler(this.needReloadDriver, this.neednotReloadTelephone)
    },
    isNullData() {
      this.carryingContacts = []
      this.truckingInfo.driver = ''
      this.truckingInfo.driverTel = ''
    },
    carryingContactsChangeHandler(needReloadDriver = false, needNotReloadTelephone = false) {
      if (!this.truckingInfo.driver) return
      this.neednotReloadTelephone = needNotReloadTelephone
      this.needReloadDriver = needReloadDriver
      if (this.carryingContacts && this.carryingContacts.length > 0) {
        for (const item of this.carryingContacts) {
          if (item && item.contactPerson && item.contactPerson === this.truckingInfo.driver) {
            if (!this.neednotReloadTelephone) {
              this.truckingInfo.driverTel = item.telephone
              break
            }
          }
        }
      } else {
        const contacts = this.carryingContacts
        if (contacts && contacts.length > 0 && this.needReloadDriver) {
          const cat = contacts[0]
          this.truckingInfo.driver = cat.contactPerson
          this.truckingInfo.driverTel = cat.telephone
        } else {
          this.truckingInfo.driver = ''
          if (this.needReloadDriver) {
            this.truckingInfo.driverTel = ''
          }
        }
      }
      this.refreshTopGrid()
    },
    onExChangeAgentChange(data) {
      this.job.exChangeAgent = data.value
      this.truckingInfo.exChangeAgent = data.value
      for (const item of this.trucking) {
        item.exChangeAgent = data.value
      }
      this.refreshTopGrid()
    },
    // 组装打印参数
    getPrintData() {
      const params = {}
      // const truckingUuids = Array.from(this.job.dischargingTrucking, p => p.uuid).join(',')
      // params.TRUCKING_UUID = StrUtils.isEmpty(truckingUuids) ? null : truckingUuids
      // params.JOB_UUID = this.job.uuid
      PrintTemplateUtil.buildPrintDataByPodTrucking(this.job, this.job.dischargingTrucking, params)
      params.category = 'POD_TRUCKING'
      return params
    },
    getSubmitData() {
      this.validateRequire(this.job.multipleDischargingPickups ? this.trucking : [this.truckingInfo])
      if (this.isMaster) {
        return {
          dischargingTruckingInfo: this.job.multipleDischargingPickups ? this.trucking : [this.truckingInfo]
        }
      }
      this.validateForm()
      this.fillModel()
      const job = { ...this.job }
      const charges = []
      if (this.job.charges && this.job.charges.length > 0) {
        for (const charge of this.job.charges) {
          if (!charge.isDirty) continue
          charges.push(charge)
        }
      }
      const result = {
        job,
        dischargingTruckingInfo: this.job.multipleDischargingPickups ? this.trucking : [this.truckingInfo],
        delDischargingTruckingInfoUuids: this.delTruckingInfoUuids
      }
      if (charges.length > 0) {
        result.charges = charges
      }
      return result
    },
    validateRequire(truckingList) {
      // UI自定义中用到
    },
    validateForm() {
      if (!this.truckingInfo.carryingCmp && this.truckingInfo.truckingFee) {
        throw new TabError(this.$t('Message.PleaseEnterTheShippingCompanyInformation'), 'tabDischargingTrucking')
      }
      const truckingMap = {}
      for (const trucking of this.trucking) {
        if (StrUtils.isEmpty(trucking.truckOrderNo)) {
          continue
        }
        if (truckingMap.hasOwnProperty(trucking.truckOrderNo)) {
          throw new TabError(this.$t('Message.SameJobtruckOrderNo'), 'tabDischargingTrucking')
        } else {
          truckingMap[trucking.truckOrderNo] = true
        }
      }
      return true
    },
    linkUsageClickHandler() {
      const serialNos = []
      for (const item of this.usages) {
        if (item.serialNo) {
          serialNos.push(String(item.serialNo))
        }
        if (!StrUtils.isEmpty(item.code)) {
          this.$message.warning(this.$t('Message.ThisCarOrderIsSendedNoAddUsage'))
          return
        }
      }
      this.containerUsageDialog.serialNos = serialNos
      this.containerUsageDialog.visible = true
    },
    // 选择装箱信息后的处理
    selectContainerUsageHandler(serialNo) {
      this.$message.success(this.$t('Message.SaveSuccessfully'))
      // 重新加载 装箱信息列表
      this.loadTruckingInfoUsage(this.truckingInfo)
      this.truckingInfo.serialNo = serialNo
      this.setContainerNo(this.trucking)
    },
    // 移除装箱信息
    delLinkUsageClickHandler() {
      const selections = this.gridApi.getSelectedRows()
      if (selections.length === 0) {
        return
      }
      this.$confirm(this.$t('Message.SureYouRemoveThisNData1') + ' ' + selections.length + ' ' + this.$t('Message.SureYouRemoveThisNData2'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning',
        closeOnClickModal: false
      }).then(() => {
        let n = true
        for (const usage of selections) {
          if (!(usage.truckStatus === '' || usage.truckStatus == null || usage.truckStatus === '03' ||
            usage.truckStatus === '05' || usage.truckStatus === '11' || usage.truckStatus === '00')) {
            this.$message.warning(this.$t('Message.ThisBoxIsNotAllowedToBeDeleted'))
            n = false
            return
          }
        }
        if (n) {
          const truckingContainerUsageKeys = Array.from(selections, p => p.uuid)
          const serialNos = []
          for (const item of this.usages) {
            if (!truckingContainerUsageKeys.includes(item.uuid) && item.serialNo) {
              serialNos.push(String(item.serialNo))
            }
          }
          const serialNo = serialNos.join(',')
          batchDeleteDischargingTruckingContainerUsages(truckingContainerUsageKeys, { serialNo }).then(res => {
            this.$message.success(this.$t('Message.DeleteSuccessfully'))
            // 重新加载装箱信息列表
            this.loadTruckingInfoUsage(this.truckingInfo)
            this.truckingInfo.serialNo = serialNo
            this.setContainerNo(this.trucking)
          })
        }
      })
    },
    // 上传附件
    uploadFileClickHandler(value) {
      // CARGO-6902，编辑状态下，箱记录的附件上传会异常，导致刚录入的拖车费没了
      if (this.isEdit) {
        return
      }
      this.uploadCommonFileDialog.model = { uuid: value }
      this.uploadCommonFileDialog.visible = true
    },
    // 费用确认
    auditUrlClickHandler(value) {
      if (value) {
        window.open(value)
      }
    },
    // 拖车费编辑
    onCellChange(params) {
      const item = params.data
      item.truckingFee = ColumnUtils.number2ColumnLabelFunc(NumberUtils.roundHalfUp(item.truckingFee, 2))
      this.gridApi.refreshCells({ force: true })
      this.truckingFeeSum()
      this.truckingFeeCharge()
      const index = this.containerUsages.findIndex(p => p.uuid === item.uuid)
      // 移除上次的记录
      if (index >= 0) {
        this.containerUsages.splice(index, 1)
      }
      // 记录装箱明细的拖车费，用于保存
      this.containerUsages.push({ uuid: item.uuid, truckingFee: item.truckingFee })
      this.truckingInfo.containerUsages = this.containerUsages
    },
    truckingFeeSum() {
      let truckingFeeSum = 0
      for (const u of this.usages) {
        if (!isNaN(u.truckingFee)) {
          truckingFeeSum += u.truckingFee
        }
      }
      if (truckingFeeSum > 0) {
        this.truckingInfo.truckingFee = truckingFeeSum
      }
    },
    selectContactBlur(event) {
      if (event && event.target && event.target.value) {
        this.truckingInfo.driver = event.target.value
      }
      this.refreshTopGrid()
    }
  }
}
</script>

<style lang="scss" scoped>
.inline-form {
  margin-left: 20px;
  label {
    font-weight: normal;
  }
  .el-form-item__content {
    & > label {
      width: 40px;
      display: inline-block;
      &:first-of-type {
        margin-left: 1px;
      }
    }
    .el-input-number {
      width: 86px;
      margin-right: 10px;
    }
  }
  .el-form-item {
    &:nth-of-type(2) {
      margin-left: 70px;
    }
    /deep/ .so-no-selector {
      & > span {
        &:first-of-type {
          flex: 1;
        }
      }
    }
  }
}
.trucking-form {
  width: 1200px;
  box-sizing: border-box;
  padding-left: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  .el-form {
    flex: 1;
    .el-form-item__content {
      & > label {
        margin: 0 10px;
        font-weight: normal;
      }
      span {
        &.currency {
          margin-left: 10px;
        }
      }
    }
    .plate_number {
      width: 280px;
      height: 28px;
      box-sizing: border-box;
      padding-left: 10px;
      vertical-align: middle;
      background-color: #f3f4f5;
      border: 1px solid #e4e7ed;
      color: blue;
      text-decoration: underline;
      cursor: pointer;
      display: inline-block;
    }
    .vehicle-btn {
      margin-left: 10px;
    }
    .vehicle-tip {
      margin-left: 5px;
      font-size: 16px;
      color: #1f75d5;
    }
  }
}
</style>
